import React from "react";
import Typewriter from "typewriter-effect";
import "../App.css"
import { memo } from "react";

function Type() {
  return (
    <div className="type">

        <Typewriter
              options={{
                strings: [
                  "A Full Stack Web Developer",
                  "With Intuitive Problem",
                  "Solving Skills ."
                ],
                autoStart: true,
                loop: true,
                deleteSpeed: 40,
              }}
            />
    </div>
   
  );
}

export default memo(Type);